import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'swiper/css/bundle';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.css';

// Components
import Header from './components/Header';
import FeatureCards from './components/FeatureCards';
import Footer from './components/Footer';

// Pages
import AgroIndex from './components/AgroIndex';
import AboutPage from './components/AboutPage';
import VegetablesPage from './components/VegetablesPage';
import SpicesPage from './components/SpicesPage';
import HomeStayPage from './components/HomeStayPage';
import AboutUsPage from './components/AboutUsPage';
import ProductsPage from './pages/ProductsPage';
import Acontact from './components/Acontact';
import RoomsPage from './components/RoomsPage';
import ServicesPage from './components/ServicesPage'; // Import ServicesPage
import BlogPage from './components/BlogPage'; // Import BlogPage
import ContactPage from './components/ContactPage';
// import ServicesPage from './components/ServicesPage';




function App() {
  useEffect(() => {
    // Initialize AOS
    AOS.init({
      duration: 800,
      once: false,
      mirror: true,
      offset: 40,
      easing: 'ease-out-quad'
    });
  }, []);

  return (
    <Router>
      <div className="App">
        <main>
          <Routes>
            {/* Home Route */}
            <Route path="/" element={
              <>
                <Header />
                <FeatureCards />
              </>
            } />
            
            {/* Agro Index Route */}
            <Route path="/agroindex" element={<AgroIndex />} />
            
            {/* About Page Route */}
            <Route path="/about" element={<AboutPage />} />
            
            {/* Vegetables Page Route */}
            <Route path="/vegetables" element={<VegetablesPage />} />
            
            {/* Spices Page Route */}
            <Route path="/spices" element={<SpicesPage />} />
            
            {/* Contact Page Route */}
            <Route path="/acontact" element={<Acontact />} />
            <Route path="/homestay" element={<HomeStayPage />} />
            <Route path="/aabout" element={<AboutUsPage />} />
            <Route path="/blog" element={<BlogPage />} />

            <Route path="/kabini-group" element={<ServicesPage />} />

            {/* Rooms Page Route */}
            <Route path="/rooms" element={<RoomsPage />} />
            
            {/* Services Page Route */}
            {/* <Route path="/services" element={<ServicesPage />} /> */}
            <Route path="/contact" element={<ContactPage />} />

            
            {/* Products Category Routes */}
            <Route path="/products/:category" element={<ProductsPage />} />
            
            {/* Fruits Route */}
            <Route path="/fruits" element={<ProductsPage category="fruits" />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;